import React, { ReactNode } from 'react';
import styled from 'styled-components';

import { CARD_WRAPPER_TYPES } from '../../../shared/constants';

import mq from '../../../styles/breakpoints';
import Colors from '../../../styles/colors';
import { ProductPageH2 } from '../../../styles/generic';
import Spacings from '../../../styles/Spacings';

interface Props {
  title?: string;
  children?: ReactNode;
}

const FeedbackCard = ({ title, children }: Props) => (
  <Component id={CARD_WRAPPER_TYPES.feedbackCardWrapper}>
    {title && <ProductPageH2>{title}</ProductPageH2>}
    <Card>{children}</Card>
  </Component>
);

export default FeedbackCard;

export const Component = styled.section`
  box-sizing: border-box;
  width: 100%;
`;

const Card = styled.div`
  background: ${Colors.white};
  box-shadow: ${({ theme }) => theme.elevations.abnElevationWell};
  padding: ${Spacings.M} ${Spacings.S};

  ${mq.from.breakpoint.L`
    padding: ${Spacings.L};
  `}
`;
